export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geschäft"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anwenden"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alles löschen"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status auswählen"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geschäft auswählen"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechnungsnummer eingeben"])}
}